import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import MarketAnalysis from './pages/MarketAnalysis';
import DealFinder from './pages/DealFinder';
import ProductDetail from './pages/ProductDetail';
import TradeIn from './pages/TradeIn';
import PhoneGrading from './pages/PhoneGrading';
import Inventory from './pages/Inventory';
import OrderManagement from './pages/OrderManagement';
import TraderCRM from './pages/TraderCRM';
import WholesaleAuctions from './pages/WholesaleAuctions';
import UserProfile from './pages/UserProfile';
import RiskAssessment from './pages/RiskAssessment';
import SyndicateHub from './pages/SyndicateHub';
import SyndicateCreation from './pages/SyndicateCreation';
import SyndicateDetail from './pages/SyndicateDetail';
import SyndicateContribution from './pages/SyndicateContribution';
import SyndicateDistribution from './pages/SyndicateDistribution';
import Layout from './components/Layout';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
export function App() {
  useEffect(() => {
    // HubSpot Tracking Code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js.hs-scripts.com/51051096.js';
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('hs-script-loader');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);
  return <ThemeProvider data-id="element-0">
      <AuthProvider data-id="element-1">
        <Router data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Layout data-id="element-5">
                  <Dashboard data-id="element-6" />
                </Layout>} data-id="element-4" />
            <Route path="/market-analysis" element={<Layout data-id="element-8">
                  <MarketAnalysis data-id="element-9" />
                </Layout>} data-id="element-7" />
            <Route path="/deal-finder" element={<Layout data-id="element-11">
                  <DealFinder data-id="element-12" />
                </Layout>} data-id="element-10" />
            <Route path="/product/:id" element={<Layout data-id="element-14">
                  <ProductDetail data-id="element-15" />
                </Layout>} data-id="element-13" />
            <Route path="/trade-in" element={<Layout data-id="element-17">
                  <TradeIn data-id="element-18" />
                </Layout>} data-id="element-16" />
            <Route path="/phone-grading" element={<Layout data-id="element-20">
                  <PhoneGrading data-id="element-21" />
                </Layout>} data-id="element-19" />
            <Route path="/inventory" element={<Layout data-id="element-23">
                  <Inventory data-id="element-24" />
                </Layout>} data-id="element-22" />
            <Route path="/order-management" element={<Layout data-id="element-26">
                  <OrderManagement data-id="element-27" />
                </Layout>} data-id="element-25" />
            <Route path="/trader-crm" element={<Layout data-id="element-29">
                  <TraderCRM data-id="element-30" />
                </Layout>} data-id="element-28" />
            <Route path="/wholesale-auctions" element={<Layout data-id="element-32">
                  <WholesaleAuctions data-id="element-33" />
                </Layout>} data-id="element-31" />
            <Route path="/syndicate-hub" element={<Layout data-id="element-35">
                  <SyndicateHub data-id="element-36" />
                </Layout>} data-id="element-34" />
            <Route path="/syndicate-creation" element={<Layout data-id="element-38">
                  <SyndicateCreation data-id="element-39" />
                </Layout>} data-id="element-37" />
            <Route path="/syndicate-detail/:id" element={<Layout data-id="element-41">
                  <SyndicateDetail data-id="element-42" />
                </Layout>} data-id="element-40" />
            <Route path="/syndicate-contribution/:id" element={<Layout data-id="element-44">
                  <SyndicateContribution data-id="element-45" />
                </Layout>} data-id="element-43" />
            <Route path="/syndicate-distribution/:id" element={<Layout data-id="element-47">
                  <SyndicateDistribution data-id="element-48" />
                </Layout>} data-id="element-46" />
            <Route path="/risk-assessment" element={<Layout data-id="element-50">
                  <RiskAssessment data-id="element-51" />
                </Layout>} data-id="element-49" />
            <Route path="/profile" element={<Layout data-id="element-53">
                  <UserProfile data-id="element-54" />
                </Layout>} data-id="element-52" />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>;
}